// extracted by mini-css-extract-plugin
module.exports = {"root":"_24IHM","calendarRoot":"w9hQ0","icon":"OW2fq"};